import React from 'react';

const HscStatsColumns = ({title = '', columns = []}) => {
    return (
        <React.Fragment>
            <div className={`stats-title green`} style={{marginBottom: 'unset'}}>
                <a href={"https://chathamdirect.com/rates/market-rates/us"} target='_blank'>{title}</a>
            </div>
            <div className="table-container">
                <table className="stats-vertical-table">
                    <thead>
                    <tr>
                        <th className="header-cell" />
                        <th className="header-cell">Current</th>
                        <th className="header-cell">1 Yr Prior</th>
                    </tr>
                    </thead>
                    <tbody>
                    {columns.map((row, idx) => (
                        <tr key={idx}>
                        <td className="row-header">{row.label}</td>
                        <td className="row-data">{row.current}</td>
                        <td className="row-data">{row.prior}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
        </React.Fragment>
    );
};

export default HscStatsColumns;